import { Any, JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('InvoiceResponce')
export class InvoiceResponce {
  @JsonProperty('invoiceIds', String, true) invoiceIds: string = undefined;
  @JsonProperty('invalidInvoiceNumbers', String, true) invalidInvoiceNumbers: string = undefined;
}
